import "zod/compile";
import { z } from "zod";

/**
 * Who acted *through* Nami. The signed-in user is always the actor of record
 * (audit rows carry their `user_id`); the channel says the change was made by
 * the agent on that user's instruction, and points back at the conversation
 * and tool call so a reviewer can open the transcript.
 */
export const AgentChannelSchema = z.object({
  agent: z.literal("nami"),
  threadId: z.string().optional(),
  toolCallId: z.string().optional(),
  toolName: z.string().optional(),
});
export type AgentChannel = z.infer<typeof AgentChannelSchema>;

/** Reads an `AgentChannel` out of loosely-typed metadata, or null when absent or malformed. */
export function parseAgentChannel(value: unknown): AgentChannel | null {
  const parsed = AgentChannelSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
